import Telegram from "../../assets/Telegram.svg";
import Close from "../../assets/UI Elements/Cross.svg";

export default function Menu({ isOpen, onClose }) {
  return (
    <div
      className={`fixed top-0 right-0 h-full max-w-[280px] bg-white z-[60] transform transition-transform duration-300 md:hidden tracking-normal ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="py-[20px] px-[24px] h-full flex flex-col gap-[20px]">
        <div className="flex justify-end">
          <button onClick={onClose}>
            <img src={Close} alt="Close" />
          </button>
        </div>

        <nav className="flex flex-col gap-[12px] text-[#4d4d4d]">
          <a href="/" onClick={onClose} className="text-[18px]">
            О продукте
          </a>
          <a href="/#apps" onClick={onClose} className="text-[18px]">
            Где скачать
          </a>
          {/* <a href="/#tariffs" onClick={onClose} className="text-[18px]">
            Тарифы
          </a> */}
        </nav>

        <div className="mt-auto">
          <a
            href="https://t.me/sobesednik_supportbot"
            target="_blank"
            rel="noopener noreferrer"
            className="pl-[12px] pr-[16px] py-[8px] flex justify-between bg-[#f4f1ff] rounded-[12px]"
          >
            <p className="text-[#4d4d4d]">Поддержка</p>
            <img src={Telegram} alt="Logo" />
          </a>
        </div>
      </div>
    </div>
  );
}
